import cn from 'classnames'
import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'

import { Translation } from 'cng-common/features/translations'
import { Tooltip } from 'core-components/library/tooltip'
import { ICompetitorsSobChangeLog } from 'partner360/models/competitorsSob/ICompetitorsSobChangeLog'
import { ISobCompetitorsGroup } from 'partner360/models/ISobCompetitorsGroup'

import { TRANSLATION_KEYS } from '../../../translations'
import { SobCompetitorItems } from '../sobCompetitorItems/SobCompetitorItems'

import styles from './NameColumn.module.scss'

interface INameColumnProps {
  item: ISobCompetitorsGroup
  isDisplaySellThru: boolean
  changes: ICompetitorsSobChangeLog[]
}

export const NameColumn = ({ item, isDisplaySellThru, changes }: INameColumnProps) => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.titleText}>{item.Name}</p>
      <SobCompetitorItems
        item={item}
        isDisplaySellThru={isDisplaySellThru}
        renderContent={(comp) => {
          const foundChangesItem = changes.find(
            (el) => el.CompetitorID === comp.CompetitorID && el.EntryId === item.EntryId
          )

          const hasChanges = foundChangesItem && foundChangesItem.changedFields.length > 0

          return (
            <div className={styles.competitor}>
              <div
                className={cn(styles.competitor__valueTypes__valueType, styles.competitor__name, {
                  [styles.competitor__valueTypes__valueType__onlySob]: !isDisplaySellThru,
                })}
              >
                {comp.CompetitorName}
                <RenderWhen condition={hasChanges}>
                  <Tooltip
                    className={styles.iconChanges}
                    tipContent={() => <Translation text={TRANSLATION_KEYS.hasChanges} />}
                  >
                    <i className={cn('kbase kbase-dot')} />
                  </Tooltip>
                </RenderWhen>
              </div>

              <div className={styles.competitor__valueTypes}>
                <div
                  className={cn(styles.competitor__valueTypes__valueType, {
                    [styles.competitor__valueTypes__valueType__onlySob]: !isDisplaySellThru,
                  })}
                >
                  <Translation text={TRANSLATION_KEYS.sobTitle} />
                </div>
                <div
                  className={cn(
                    styles.competitor__valueTypes__valueType,
                    styles.competitor__valueTypes__valueType__yoy,
                    {
                      [styles.competitor__valueTypes__valueType__onlySob]: !isDisplaySellThru,
                    }
                  )}
                >
                  <Translation text={TRANSLATION_KEYS.yoyTitle} />
                </div>
                <div
                  className={cn(
                    styles.competitor__valueTypes__valueType,
                    styles.competitor__valueTypes__valueType__yoy,
                    {
                      [styles.competitor__valueTypes__valueType__onlySob]: !isDisplaySellThru,
                    }
                  )}
                >
                  <Translation text={TRANSLATION_KEYS.qoqTitle} />
                </div>
                <RenderWhen condition={isDisplaySellThru}>
                  <div className={styles.competitor__valueTypes__valueType}>
                    <Translation text={TRANSLATION_KEYS.sellThruTitle} />
                  </div>
                </RenderWhen>
              </div>
            </div>
          )
        }}
      />
    </div>
  )
}
